<template>
  <div class="w-100 h-100">
    <div class="d-sm-block d-md-none mx-3 mt-5">
      <div class="d-flex align-items-start flex-column 100-vh h-100">
        <!-- <div class="HomepageHeroGradient Gradient isLoaded">
          <canvas
            id="canv"
            class="Gradient__canvas isLoaded"
            data-js-controller="Gradient"
            data-js-darken-top=""
            data-transition-in=""
            width="375"
            height="600"
          ></canvas>
        </div> -->
        <h2 class="mdc-typography--headline3 font-weight-bold">
          {{ $t('title') }}
          <vue-typed-js
            :strings="[$t('word1'), $t('word2'), $t('word3')]"
            :typeSpeed="80"
            :startDelay="2000"
            :showCursor="false"
            :cursorChar="'_'"
          >
            <h3 class="mdc-typography--headline3 font-weight-bold">
              <span class="typing"></span>
            </h3>
          </vue-typed-js>
        </h2>
        <p class="mdc-typography--subtitle1">
          {{ $t('description') }}
        </p>
        <button
          class="mdc-button mdc-button--outlined"
          data-toggle="modal"
          data-target="#exampleModal"
        >
          <span class="mdc-button__ripple"></span>{{ $t('feature.beta') }}
        </button>
      </div>
      <div class="d-flex align-items-start flex-column pt-5">
        <h2 class="mdc-typography--headline6 font-weight-bold">
          Why Surfverse
        </h2>
        <h1 class="mdc-typography--headline4 font-weight-bold">
          A minimalistic approach to a startup ecosystem.
        </h1>
        <div class="ColumnLayout">
          <section class="Verse">
            <header class="Verse__header">
              <div class="Verse__icon">
                <img src="/img/mobile/awareness.svg" />
              </div>
              <h1 class="Verse__title mdc-typography--headline5">
                We start with a Collaborative Mentality.
              </h1>
            </header>
            <div class="Verse_body">
              <p>
                A startup ecosystem is formed by people, startups in their
                various stages and various types of organizations in a location
                (physical and/or virtual), interacting as a system to create new
                startup companies.
              </p>
            </div>
          </section>
          <section class="Verse">
            <header class="Verse__header">
              <div class="Verse__icon">
                <img src="/img/mobile/research.svg" />
              </div>
              <h1 class="Verse__title mdc-typography--headline5">
                We map the Market.
              </h1>
            </header>
            <div class="Verse_body">
              <p>
                A startup ecosystem is formed by people, startups in their
                various stages and various types of organizations in a location
                (physical and/or virtual), interacting as a system to create new
                startup companies.
              </p>
            </div>
          </section>
          <section class="Verse">
            <header class="Verse__header">
              <div class="Verse__icon">
                <img src="/img/mobile/matching.svg" />
              </div>
              <h1 class="Verse__title mdc-typography--headline5">
                We Gather the Network.
              </h1>
            </header>
            <div class="Verse_body">
              <p>
                A startup ecosystem is formed by people, startups in their
                various stages and various types of organizations in a location
                (physical and/or virtual), interacting as a system to create new
                startup companies.
              </p>
            </div>
          </section>
          <section class="Verse">
            <header class="Verse__header">
              <div class="Verse__icon">
                <img src="/img/mobile/volunteering.svg" />
              </div>
              <h1 class="Verse__title mdc-typography--headline5">
                We work with with your Government.
              </h1>
            </header>
            <div class="Verse_body">
              <p>
                A startup ecosystem is formed by people, startups in their
                various stages and various types of organizations in a location
                (physical and/or virtual), interacting as a system to create new
                startup companies.
              </p>
            </div>
          </section>
          <section class="Verse">
            <header class="Verse__header">
              <div class="Verse__icon">
                <img src="/img/mobile/guides.svg" />
              </div>
              <h1 class="Verse__title mdc-typography--headline5">
                We Stay Honest.
              </h1>
            </header>
            <div class="Verse_body">
              <p>
                A startup ecosystem is formed by people, startups in their
                various stages and various types of organizations in a location
                (physical and/or virtual), interacting as a system to create new
                startup companies.
              </p>
            </div>
          </section>
        </div>
      </div>
      <div class="d-flex align-items-start flex-column pt-5">
        <h2 class="mdc-typography--headline6 font-weight-bold">
          Unified Network
        </h2>
        <h1 class="mdc-typography--headline4 font-weight-bold">
          A fully integrated suite of professional networks.
        </h1>
        <section class="Verse">
          <header class="Verse__header">
            <div class="Verse__icon">
              <img src="/img/mobile/community-2.svg" />
            </div>
            <h1 class="Verse__title mdc-typography--headline5">Title</h1>
          </header>
          <div class="Verse_body">
            <p>
              We bring together everything that’s required to launch a startup.
              Talent, Education, Locations and Events, Mentorship, Incubators
              and Accelerators, Funding.
            </p>
          </div>
        </section>
      </div>
    </div>
    <div class="d-none d-sm-block">
      <div
        class="pt-5 mt-1 description-hero flex-wrapper col-6 mx-auto d-flex justify-content-center"
      >
        <!-- Introduction -->
        <!-- Feature 1 -->
        <vue-typed-js
          :strings="['under construction']"
          :typeSpeed="80"
          :startDelay="2000"
          :showCursor="false"
          :cursorChar="'_'"
        >
          <h3
            class="mdc-typography--headline4 text-color text-intro text-uppercase"
          >
            👷‍♀️🚧<span class="typing"></span>🚧👷‍♂️
          </h3>
        </vue-typed-js>
      </div>
      <!-- <div class="d-flex justify-content-center text-uppercase">
      <vue-typed-js :strings="['building']" :typeSpeed="80" :startDelay="4000">
        <h3 class="mdc-typography--headline4 text-color text-intro">
          Start <span class="typing"></span>
        </h3>
      </vue-typed-js>
    </div>
    <div class="d-flex justify-content-center">
      <vue-typed-js
        :strings="['Better', 'Faster', 'Together', 'From Home.👨‍💻']"
        :typeSpeed="80"
        :startDelay="3000"
      >
        <h3 class="mdc-typography--body2 text-color text-center text-intro">
          Every <span class="typing"></span> we take comes from the ocean
        </h3>
      </vue-typed-js>
    </div> -->

      <div
        class="_8iil"
        data-aos="fade-up"
        data-aos-delay="3000"
        data-aos-duration="2000"
        data-aos-anchor-placement="center-bottom"
        data-aos-easing="ease-out-sine"
      >
        <div class="_8ij2">
          <section class="_8ry0">
            <div>
              <div class="cd-app-screen ">
                <div class="cd-product cd-container">
                  <div class="cd-product-wrapper">
                    <!-- <img
                    class="img"
                    style="animation-play-state: running;"
                    alt="Găseşte mai rapid ceea ce îţi place"
                    src="../../public/img/darkmode/profile3.png"
                    width="100%"
                    height="auto"
                    loading="lazy"
                  /> -->
                    <picture>
                      <source
                        media="(prefers-color-scheme: dark)"
                        srcset="../../public/img/darkmode/profile-dark.webp"
                        type="image/webp"
                      />
                      <!-- <source
                        media="(prefers-color-scheme: light)"
                        srcset="../../public/img/darkmode/profile-light.webp"
                        type="image/webp"
                      /> -->
                      <!-- <source
                        media="(prefers-color-scheme: light)"
                        srcset="../../public/img/darkmode/profile-light.jpg"
                        type="image/jpeg"
                      /> -->
                      <source
                        srcset="../../public/img/darkmode/profile-dark.jpg"
                        media="(prefers-color-scheme: dark)"
                        type="image/jpeg"
                      />
                      <img
                        class="img"
                        style="animation-play-state: running;"
                        alt="Găseşte mai rapid ceea ce îţi place"
                        src="../../public/img/darkmode/profile-dark.jpg"
                        id="screenshot"
                        loading="lazy"
                        width="100%"
                        height="auto"
                      />
                    </picture>
                  </div>
                  <!-- .cd-product-wrapper -->
                </div>
                <!-- .cd-product -->
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="mdc-layout-grid demo-grid">
        <div class="mdc-layout-grid__inner">
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <a href="/features/radar">
                <h6
                  class="mdc-typography--headline6 text-nav text-color text-center"
                >
                  {{ $t('feature1.title') }}
                </h6></a
              >
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature1.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <a href="/business/jobs">
                <h6
                  class="mdc-typography--headline6 text-nav text-color text-center"
                >
                  {{ $t('feature2.title') }}
                </h6></a
              >
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature2.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature3.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature3.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature4.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature4.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature5.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature5.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature6.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature6.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature7.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature7.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature8.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature8.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature9.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature9.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature10.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature10.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature11.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature11.description') }}
              </p>
            </div>
          </div>
          <div
            class="mdc-layout-grid__cell title-cell feature-cell mdc-layout-grid__cell--span-3-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-1-phone"
          >
            <div id="desc">
              <h6
                class="mdc-typography--headline6 text-nav text-color text-center"
              >
                {{ $t('feature12.title') }}
              </h6>
              <p class="mdc-typography--subtitle2 text-center">
                {{ $t('feature12.description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DarkMode'
}
</script>

<i18n>
{
  "en": {
    "title": "Professional network for",
    "description": "Businesses of all sizes—from startups to large enterprises—use Surfverse Platform and APIs to launch products, make investments, hiring, and manage their businesses online.",
    "word1": "workers", 
    "word2": "startups", 
    "word3": "founders",
    "feature1": {
      "title": "Radar",
      "description": "A directory for companies and startups"
    },
    "feature2": {
      "title": "Jobs",
      "description": "Search or post a dream job"
    },
    "feature3": {
      "title": "Discussions",
      "description": "Get help or help others"
    },
    "feature4": {
      "title": "Profiles",
      "description": "Profile for you, businesses or institutions"
    },
    "feature5": {
      "title": "News Feed",
      "description": "A personal feed build from your subs"
    },
    "feature6": {
      "title": "Groups",
      "description": "Create one or join others"
    },
    "feature7": {
      "title": "Chat",
      "description": "With user presence and many more"
    },
    "feature8": {
      "title": "Posts",
      "description": "Share your thoughts"
    },
    "feature9": {
      "title": "Maps",
      "description": "See what's happening live on the map"
    },
    "feature10": {
      "title": "Studio",
      "description": "Build your stories like never before"
    },
    "feature11": {
      "title": "Photos",
      "description": "Add the magic of Google Photos"
    },
    "feature12": {
      "title": "Developers",
      "description": "Use our API's for your next project"
    }
  },
  "ro": {
    "title": "Rețea Profesională Pentru",
    "description": "Întreprinderile de toate dimensiunile - de la startup-uri la întreprinderi mari - utilizează platforma Surfverse și API-urile noastre pentru a lansa produse, a face investiții, a angaja și a-și gestiona afacerile online.",
    "word1": "Fondatori",
    "word2": "Angajați", 
    "word3": "Startup-uri",
    "feature1": {
      "title": "Radar",
      "description": "Un director pentru companii și startup-uri"
    },
    "feature2": {
      "title": "Jobs",
      "description": "Căutați sau postați un job"
    },
    "feature3": {
      "title": "Discuţii",
      "description": "Participați la discuțiile antreprenorilor"
    },
    "feature4": {
      "title": "Profile",
      "description": "Profil pentru dvs., companii sau instituții"
    },
    "feature5": {
      "title": "Noutăți",
      "description": "Un flux personalizat intereselor tale"
    },
    "feature6": {
      "title": "Grupuri",
      "description": "Creați unul sau alăturați-vă altora"
    },
    "feature7": {
      "title": "Chat",
      "description": "Cu prezență și multe altele"
    },
    "feature8": {
      "title": "Articole",
      "description": "Împărtășește-ți experiențele"
    },
    "feature9": {
      "title": "Hărți",
      "description": "Vedeți ce se întâmplă chiar acum, dar pe hartă"
    },
    "feature10": {
      "title": "Studio",
      "description": "Un nou mod de a crea postări"
    },
    "feature11": {
      "title": "Fotografii",
      "description": "Adaugă magia Google Foto"
    },
    "feature12": {
      "title": "Dezvoltatori",
      "description": "Folosiți API-ul nostru pentru următorul dvs. proiect"
    }
  },
  "de": {
    "title": "Professional network for founders",
    "description": "Businesses of all sizes—from startups to large enterprises—use Surfverse Platform and APIs to launch products, make investments, hiring, and manage their businesses online.",
    "word1": "workers",
    "word2": "startups", 
    "word3": "founders",
    "feature1": {
      "title": "Radar",
      "description": "A directory for companies and startups"
    },
    "feature2": {
      "title": "Jobs",
      "description": "Search or post a dream job"
    },
    "feature3": {
      "title": "Discussions",
      "description": "Get help or help others"
    },
    "feature4": {
      "title": "Profiles",
      "description": "Profile for you, businesses or institutions"
    },
    "feature5": {
      "title": "News Feed",
      "description": "A personal feed build from your subs"
    },
    "feature6": {
      "title": "Groups",
      "description": "Create one or join others"
    },
    "feature7": {
      "title": "Chat",
      "description": "With user presence and many more"
    },
    "feature8": {
      "title": "Posts",
      "description": "Share your thoughts"
    },
    "feature9": {
      "title": "Maps",
      "description": "Explore the world around you"
    },
    "feature10": {
      "title": "Studio",
      "description": "Build your stories like never before"
    },
    "feature11": {
      "title": "Photos",
      "description": "Add the magic of Google Photos"
    },
    "feature12": {
      "title": "Developers",
      "description": "Use our API's for your next project"
    }
  }
}
</i18n>

<style>
@media (max-width: 575.98px) {
  /* #app {
    background-color: transparent !important;
  } */
}
.HomepageHeroGradient {
  --gradientColorZero: #ff7878;
  --gradientColorOne: #ff333d;
  --gradientColorTwo: #71a7ff;
  --gradientColorThree: #ffc107;
  --gradientColorZeroTransparent: rgba(169, 96, 238, 0);
  --gradientColorOneTransparent: rgba(255, 51, 61, 0);
  --gradientColorTwoTransparent: rgba(144, 224, 255, 0);
  --gradientColorThreeTransparent: rgba(255, 203, 87, 0);
  --windowWidth: 100vw;
  --gradientAngle: -12deg;
  --gradientHeight: calc(100% + calc(72 * 1px) + calc(-60px * 0.212));
  --offsetX: 16px;
  --transformOriginX: -60px;
  --sectionAngleSin: 0.212;
  position: absolute;
  bottom: 0;
  top: auto;
  left: calc(var(--offsetX) * -1);
  width: var(--windowWidth);
  min-width: var(--windowWidth);
  height: var(--gradientHeight);
  -webkit-transform-origin: var(--transformOriginX) 100%;
  transform-origin: var(--transformOriginX) 100%;
  -webkit-transform: skewY(var(--gradientAngle));
  transform: skewY(var(--gradientAngle));
  overflow: hidden;
  border: none;
  z-index: -1;
}
.Gradient__canvas.isLoaded {
  opacity: 1;
  -webkit-transition: opacity 1.8s ease-in 50ms;
  transition: opacity 1.8s ease-in 50ms;
}
.Gradient__canvas {
  position: relative;
  display: block;
  width: inherit;
  height: 100%;
  opacity: 0;
}
.Gradient.isLoaded:after {
  -webkit-transition: -webkit-transform 1s 1s;
  transition: -webkit-transform 1s 1s;
  transition: transform 1s 1s;
  transition: transform 1s 1s, -webkit-transform 1s 1s;
  -webkit-transform: scaleY(0.995);
  transform: scaleY(0.995);
}
.Gradient:after {
  content: '';
  z-index: -100;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
        var(--gradientColorZero) 20%,
        var(--gradientColorTwoTransparent) 40%
      ) -322px -80px no-repeat,
    radial-gradient(
        var(--gradientColorThree) 33%,
        var(--gradientColorThreeTransparent) 67%
      ) -120px -24px no-repeat,
    radial-gradient(
        var(--gradientColorTwo) 40%,
        var(--gradientColorTwoTransparent) 70%
      ) -50px 350px no-repeat,
    var(--gradientColorZero);
  /* background: radial-gradient(
        var(--gradientColorZero) 40%,
        var(--gradientColorTwoTransparent) 60%
      ) -620px -180px no-repeat,
    radial-gradient(
        var(--gradientColorThree) 33%,
        var(--gradientColorThreeTransparent) 67%
      ) -120px -24px no-repeat,
    radial-gradient(
        var(--gradientColorTwo) 40%,
        var(--gradientColorTwoTransparent) 70%
      ) -470px 150px no-repeat,
    var(--gradientColorZero); */
}
.ColumnLayout {
  --columnRowGap: 32px;
  display: grid;
  row-gap: var(--columnRowGap);
  -webkit-box-align: start;
  align-items: flex-start;
}
.Verse {
  display: grid;
  row-gap: 8px;
}

.Verse .Verse__header {
  display: grid;
  row-gap: 8px;
}
.Verse__header {
  position: relative;
  padding: 0 16px;
}
.Verse__title {
  position: relative;
  letter-spacing: 0.2px;
  font-size: 15px;
  font-weight: 425;
}
.Verse__title:before {
  position: absolute;
  top: 5px;
  left: -16px;
  width: 1px;
  height: 20px;
  background-color: #ffc107;
  content: '';
}
.Verse__icon {
  min-height: 40px;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: end;
  align-items: flex-end;
  margin-bottom: 8px;
}
.Verse__icon img {
  width: 40px;
}

.pointer {
  cursor: pointer;
}
/* .feature-cell {
  background: linear-gradient(rgb(0 0 0 / 70%), rgb(0 0 0 / 70%)),
    url(https://static.dribbble.com/users/3015858/screenshots/6711766/discuss_the_work_4x.jpg?compress=1&resize=1200x900) !important;
  background-position: center;
  background-size: cover;
} */
.feature-cell:hover {
}
#desc {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
span.typing {
  flex: 1;
  height: 100%;
  min-height: 58px;
  position: unset;
}
.typed-element {
  font-family: Oswald;
  font-size: 80px !important;
  min-height: 58px;
}
/* .typing {
  margin-left: 8px !important;
} */
/* .typed-cursor {
  margin-right: 8px !important;
} */
.text-intro {
  font-family: Oswald;
  font-size: 2vw;
  line-height: 1.05;
}
.description-hero {
  margin-top: 18vh !important;
}
.cd-app-screen::before {
  top: 0;
  left: 0;
  height: 40px;
  width: 100%;
  background: #1c1a1e;
  border-radius: 4px 4px 0 0;
  content: 'EARLY PREVIEW' !important;
  position: absolute;
  text-align: center;
  padding: 9px;
  font-style: normal;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 3.5px;
  color: #00a15f;
  font-family: Chakra Petch, sans-serif;
}
.cd-app-screen::after {
  top: 14px;
  left: 31px;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  box-shadow: -12px 0px 0px #307eff, 12px 0px 0px #ffba30, 36px 0px 0px #ff3030,
    62px 0px 0px #00a15f;
  content: '';
  position: absolute;
}
.cd-app-screen {
  border-radius: 8px;
  box-shadow: 0 6px 52px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05);

  padding-top: 56.1%;
  position: relative;
  transform: translate3d(0, 0, 0);
  width: 100%;
}
.text-shadow {
  text-shadow: rgb(255, 255, 255) 0px 0px 5px, rgb(255, 255, 255) 0px 0px 10px,
    #e91e63 0px 0px 20px, #e91e63 0px 0px 30px, #e91e63 0px 0px 40px,
    #e91e63 0px 0px 55px, #e91e63 0px 0px 75px;
}
.neon-flicker {
  animation: flicker 1.5s alternate;
  animation-iteration-count: 3;
}
/* Animate neon flicker */
@keyframes flicker {
  0%,
  19%,
  21%,
  23%,
  25%,
  54%,
  56%,
  100% {
    text-shadow: -0.2rem -0.2rem 1rem #fff, 0.2rem 0.2rem 1rem #fff,
      0 0 2rem var(--neon-text-color), 0 0 4rem var(--neon-text-color),
      0 0 6rem var(--neon-text-color), 0 0 8rem var(--neon-text-color),
      0 0 10rem var(--neon-text-color);

    /* box-shadow:
          0 0 .5rem #fff,
          inset 0 0 .5rem #fff,
          0 0 2rem var(--neon-border-color),
          inset 0 0 2rem var(--neon-border-color),
          0 0 4rem var(--neon-border-color),
          inset 0 0 4rem var(--neon-border-color);         */
  }

  20%,
  24%,
  55% {
    text-shadow: none;
    box-shadow: none;
  }
}
</style>
